import Swiper, {Autoplay, Navigation, Pagination, Scrollbar} from 'swiper';
Swiper.use([Autoplay, Navigation, Pagination, Scrollbar]);

export default class Interieuradvies {
    constructor() {
        if (document.getElementById('interieuradvies') !== null) {
            this.initSlideshow();
            this.initSteps();
            this.initReviews();
        }
    }

    initSlideshow() {
        new Swiper('#slideshow .swiper-container', {
            slidesPerView: 1,
            autoplay: {
                delay: 2500,
            },
            speed: 1000,
        });
    }

    initSteps() {
        new Swiper('#steps .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 15,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                }
            }
        });
    }

    initReviews() {
        new Swiper('#reviews .swiper-container', {
            slidesPerView: 1,
            spaceBetween: 0,
            initialSlide: 1,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            }
        });
    }
}
